import { Spinner } from '@mr-yum/frontend-ui'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import { CartLayout } from '@/components/Cart/CartLayout'
import { NavBarProps } from '@/components/Cart/CartNavBar'

export const LoyaltyMembershipLoader = (props: NavBarProps) => (
  <CartLayout navBarProps={props}>
    <div className="flex-1" data-testid="loyalty-loader">
      <div className="flex h-full flex-col  items-center justify-center">
        <div className="mx-auto mb-5" style={{ width: 50, height: 50 }}>
          <Spinner className="text-[theme(backgroundColor.action-primary-surface)]" />
        </div>

        <p className="my-heading-sm">
          <FormattedMessage id="gjBiyj" defaultMessage="Loading..." />
        </p>
      </div>
    </div>
  </CartLayout>
)
